var React = require('react');

function CommetInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.67386 36.2946L65.795 0.0350254L4.21005 40.5274C3.94152 40.7194 3.63749 40.8545 3.31617 40.9247C2.99485 40.9949 2.66283 40.9988 2.34001 40.936C2.01719 40.8733 1.7102 40.7452 1.4374 40.5594C1.16461 40.3737 0.93164 40.1342 0.752413 39.8551C0.573187 39.5761 0.451398 39.2633 0.394348 38.9355C0.337297 38.6077 0.34615 38.2715 0.420381 37.9473C0.494611 37.623 0.632695 37.3172 0.826359 37.0482C1.02002 36.7793 1.26529 36.5526 1.54748 36.3819C1.5847 36.334 1.6251 36.3406 1.67386 36.2946Z","fill":"#0A9E50"}));
}

CommetInline.defaultProps = {"width":"132","height":"82","viewBox":"0 0 66 41","fill":"none"};

module.exports = CommetInline;

CommetInline.default = CommetInline;
